export enum OnboardingStatus {
  NOT_READY = 'onboardingNotReady',
  READY = 'onboardingReady',
  COMPLETE = 'onboardingComplete',
  INTAKE_STARTED = 'onboardingIntakeStarted',
}
